export function initScripts(element, containerSelector) {
	const container = document.querySelector(containerSelector || 'head');
	const scripts = element.querySelectorAll('script');
	// eslint-disable-next-line
	for (const scrp of scripts) {
		const script = document.createElement('script');
		// Add all attributes to new script
		// eslint-disable-next-line
		for (const attr of scrp.attributes) {
			if (attr.specified) {
				script.setAttribute(attr.name, attr.value);
			}
		}
		// Add innerHTML if exists
		if (scrp.innerHTML) {
			script.innerHTML = scrp.innerHTML;
		}
		container?.appendChild(script);
	}
}
